
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 14.19c0 3.64-2.17 5.81-5.81 5.81H13a1 1 0 01-1-1v-5.77a.5.5 0 01.49-.5l1.76-.03a.319.319 0 00.29-.25l.35-1.91a.3.3 0 00-.3-.35l-2.13.03a.508.508 0 01-.51-.49l-.04-2.45a.3.3 0 01.3-.3l2.4-.04a.3.3 0 00.3-.3l-.04-2.4a.3.3 0 00-.3-.3l-2.7.04a3 3 0 00-2.95 3.05l.05 2.75a.5.5 0 01-.49.51l-1.2.02a.3.3 0 00-.3.3l.03 1.9a.3.3 0 00.3.3l1.2-.02a.508.508 0 01.51.49l.09 5.7a1 1 0 01-1 1.02h-2.3C2.17 20 0 17.83 0 14.18V5.81C0 2.17 2.17 0 5.81 0h8.38C17.83 0 20 2.17 20 5.81v8.38z","fill":"#acb2bf"}})])
          )
        }
      }
    